import { render, staticRenderFns } from "./TreeOchart.vue?vue&type=template&id=627fa6ba&scoped=true"
import script from "./TreeOchart.vue?vue&type=script&lang=js"
export * from "./TreeOchart.vue?vue&type=script&lang=js"
import style0 from "../../statistics/css/companyOchart.css?vue&type=style&index=0&id=627fa6ba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627fa6ba",
  null
  
)

export default component.exports